import { apiSlice } from './apiSlice'

export type ReportsDashboard = {
  total_cases: number
  total_teams: number
  total_courtrooms: number
  submitted_scores_count: number
  average_total_score: number | null
  leaderboard: Array<{
    team_id: string
    team_name: string
    avg_score: number
    score_count: number
  }>
}

export const reportsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReportsDashboard: builder.query<ReportsDashboard, void>({
      query: () => '/reports/dashboard',
    }),
    exportScoresCsv: builder.query<Blob, void>({
      query: () => ({
        url: '/reports/export/scores.csv',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    exportSummaryTxt: builder.query<string, void>({
      query: () => ({
        url: '/reports/export/summary.txt',
        responseHandler: (response: Response) => response.text(),
      }),
    }),
    exportSummaryPdf: builder.query<Blob, void>({
      query: () => ({
        url: '/reports/export/summary.pdf',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
})

export const {
  useGetReportsDashboardQuery,
  useLazyExportScoresCsvQuery,
  useLazyExportSummaryTxtQuery,
  useLazyExportSummaryPdfQuery,
} = reportsApi
